import React, { useEffect, useState, useMemo, useCallback, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import {
  IconCheck,
  IconX,
  IconListDetails,
  IconEye,
  IconPhoto,
  IconSearch,
  IconChartPie,
  IconUser,
  IconCircleCheck,
  IconClock,
  IconBuildingStore,
  IconAlertTriangle,
  IconInbox,
  IconAdjustmentsHorizontal,
  IconCalendarTime,
  IconReload,
  IconRotateClockwise,
} from '@tabler/icons-react';
import Layouts from '../../layouts/Layouts';
import { getAuthorizationHeader, http, imageBaseUrl } from '../../config/http';
import { toast } from 'react-toastify';
import moment from 'moment';
import DetailItem from '../Modal/DetailItem';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { DinamicTitle } from '../../utils/DinamicTitle';

export default function HistoriPenghapusan({ isVerifikasi }) {
  DinamicTitle('Pengajuan Hapus || Komaladewi');
  const [activeTab, setActiveTab] = useState('pengajuan'); // 'pengajuan' or 'barang'
  const [data, setData] = useState([]);
  const [barangData, setBarangData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [detailItem, setDetailItem] = useState([]);
  const navigate = useNavigate();
  const userRole = (localStorage.getItem('role') || '').toLowerCase().trim();
  const canVerify = userRole === 'admin' || userRole === 'owner' || userRole === 'verifikator';
  const isOperatorToko = userRole === 'operator' || userRole === 'operator_toko';

  useEffect(() => {
    if (!isVerifikasi && !isOperatorToko) {
      toast.error('Akses ditolak: Menu Pengajuan Hapus hanya dapat diakses oleh Operator Toko', {
        toastId: 'access-denied-pengajuan-hapus',
      });
      navigate('/list-items-admin');
    }
  }, [isVerifikasi, isOperatorToko, navigate]);

  // 5-Tab Detail Modal State
  const [isOpenDetailModal, setIsOpenDetailModal] = useState(false);
  const [selectedPengajuan, setSelectedPengajuan] = useState(null);
  const [modalTab, setModalTab] = useState('ringkasan'); // 'ringkasan' | 'list' | 'operator' | 'verifikator' | 'galeri'
  const [searchModalItem, setSearchModalItem] = useState('');

  // Pagination Table State
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [barangCurrentPage, setBarangCurrentPage] = useState(1);
  const [totalBarangPages, setTotalBarangPages] = useState(1);
  const [totalBarangItems, setTotalBarangItems] = useState(0);
  const [barangFrom, setBarangFrom] = useState(0);
  const [barangTo, setBarangTo] = useState(0);
  const barangItemsPerPage = 10;

  // Filter States
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState('');
  const [cabangFilter, setCabangFilter] = useState('');
  const [operatorFilter, setOperatorFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    id: null,
    action: null,
    pengajuan: null,
  });
  const [catatanVerifikasi, setCatatanVerifikasi] = useState('');

  const confirmAction = (pengajuanOrId, action) => {
    let target = null;
    if (typeof pengajuanOrId === 'object' && pengajuanOrId !== null) {
      target = pengajuanOrId;
    } else {
      target = data.find((p) => p.id === pengajuanOrId) || selectedPengajuan;
    }
    setCatatanVerifikasi('');
    setConfirmModal({
      isOpen: true,
      id: target?.id || pengajuanOrId,
      action,
      pengajuan: target,
    });
  };

  const processConfirmAction = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!confirmModal.id || !confirmModal.action) return;
    await handlePersetujuan(confirmModal.id, confirmModal.action, catatanVerifikasi);
    setConfirmModal({ isOpen: false, id: null, action: null, pengajuan: null });
    setCatatanVerifikasi('');
    setIsOpenDetailModal(false);
  };

  // Modal Restore State
  const [restoreModal, setRestoreModal] = useState({
    isOpen: false,
    pengajuan: null,
    itemIds: [],
    itemsList: [],
  });
  const [alasanRestore, setAlasanRestore] = useState('');
  const [isSubmittingRestore, setIsSubmittingRestore] = useState(false);

  const handleOpenRestoreModal = (pengajuan, itemIds = []) => {
    const items = (pengajuan.items || [])
      .filter((c) => c.status_item !== 'restored' && (itemIds.length === 0 || itemIds.includes(c.item_id)))
      .map((c) => ({
        ...(c.item || c),
        raw_child: c,
      }));
    setAlasanRestore('');
    setRestoreModal({
      isOpen: true,
      pengajuan,
      itemIds,
      itemsList: items,
    });
  };

  const handleProcessRestore = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!alasanRestore.trim()) {
      toast.warning('Silakan isi alasan pengembalian barang ke etalase');
      return;
    }
    setIsSubmittingRestore(true);
    try {
      const payload = {
        alasan: alasanRestore.trim(),
        item_ids: restoreModal.itemIds.length > 0 ? restoreModal.itemIds : undefined,
      };
      const res = await http.post(`/item-deletions/${restoreModal.pengajuan.id}/restore`, payload, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      toast.success(res.data?.message || 'Barang berhasil dikembalikan ke etalase!');
      setRestoreModal({ isOpen: false, pengajuan: null, itemIds: [], itemsList: [] });
      setAlasanRestore('');
      fetchDataPengajuan();
      if (selectedPengajuan && selectedPengajuan.id === restoreModal.pengajuan.id) {
        const resDetail = await http.get('/item-deletions', {
          headers: { Authorization: getAuthorizationHeader() },
        });
        const freshList = resDetail.data?.data?.data || resDetail.data?.data || [];
        const fresh = freshList.find((p) => p.id === restoreModal.pengajuan.id);
        if (fresh) setSelectedPengajuan(fresh);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Gagal mengembalikan barang ke etalase');
    } finally {
      setIsSubmittingRestore(false);
    }
  };

  // Resolve Image URL Helper
  const resolveItemImageUrl = (item) => {
    if (!item) return '';
    let gData = item.gambar1 || item.gambar || item.foto;
    if (typeof gData === 'string' && (gData.startsWith('[') || gData.startsWith('{'))) {
      try {
        gData = JSON.parse(gData);
      } catch (e) {}
    }
    if (Array.isArray(gData) && gData.length > 0) {
      const path = gData[0]?.asli || gData[0]?.thumbnail || (typeof gData[0] === 'string' ? gData[0] : '');
      return path ? (path.startsWith('http') ? path : `${imageBaseUrl}${path}`) : '';
    }
    if (typeof gData === 'string' && gData.length > 0) {
      return gData.startsWith('http') ? gData : `${imageBaseUrl}${gData}`;
    }
    return '';
  };

  // Normalized Item List inside Modal
  const modalItemList = useMemo(() => {
    if (!selectedPengajuan || !selectedPengajuan.items) return [];
    return selectedPengajuan.items
      .map((child) => {
        const itemObj = child.item || child;
        if (!itemObj) return null;
        return {
          ...itemObj,
          status_item: child.status_item || (selectedPengajuan.status_pengajuan === 'approved' ? 'deleted' : selectedPengajuan.status_pengajuan),
          restored_at: child.restored_at,
          restored_by: child.restored_by || child.restoredBy,
          alasan_restore: child.alasan_restore,
          raw_child: child,
        };
      })
      .filter(Boolean);
  }, [selectedPengajuan]);

  // Filtered Items inside Modal (Tab List & Tab Galeri)
  const filteredModalItems = useMemo(() => {
    if (!modalItemList.length) return [];
    if (!searchModalItem.trim()) return modalItemList;
    const q = searchModalItem.toLowerCase();
    return modalItemList.filter((it) => {
      const kode = it.kode_item ? it.kode_item.toLowerCase() : '';
      const jenis = it.jenis_kategori?.nama_jenis ? it.jenis_kategori.nama_jenis.toLowerCase() : '';
      const kat = it.jenis_kategori?.kategori?.nama_kategori ? it.jenis_kategori.kategori.nama_kategori.toLowerCase() : '';
      const baki = it.nomor_rak ? it.nomor_rak.toString().toLowerCase() : '';
      return kode.includes(q) || jenis.includes(q) || kat.includes(q) || baki.includes(q);
    });
  }, [modalItemList, searchModalItem]);

  const detailSummary = useMemo(() => {
    if (!selectedPengajuan || !selectedPengajuan.items) return {};
    return selectedPengajuan.items.reduce((acc, child) => {
      const item = child.item || child;
      if (!item) return acc;
      const catName = item.jenis_kategori?.kategori?.nama_kategori || 'Tanpa Kategori';
      const karat = item.karat || '-';
      const berat = parseFloat(item.berat || 0);

      if (!acc[catName]) acc[catName] = { name: catName, pcs: 0, berat: 0, byKarat: {} };
      acc[catName].pcs += 1;
      acc[catName].berat += berat;

      if (!acc[catName].byKarat[karat]) acc[catName].byKarat[karat] = { pcs: 0, berat: 0 };
      acc[catName].byKarat[karat].pcs += 1;
      acc[catName].byKarat[karat].berat += berat;

      return acc;
    }, {});
  }, [selectedPengajuan]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isDateOpen, setIsDateOpen] = useState(false);

  const selectionRange = {
    startDate: startDate || new Date(),
    endDate: endDate || new Date(),
    key: 'selection',
  };

  const handleSelectDate = (date) => {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  };

  const fetchDataPengajuan = useCallback(async () => {
    setLoading(true);
    try {
      const res = await http.get('/item-deletions', {
        headers: { Authorization: getAuthorizationHeader() },
      });
      let result = res.data.data || [];
      if (startDate && endDate) {
         result = result.filter(item => {
           const date = moment(item.created_at);
           return date.isBetween(moment(startDate).startOf('day'), moment(endDate).endOf('day'), null, '[]');
         });
      }
      setData(result);
    } catch (err) {
      console.log(err);
      toast.error('Gagal mengambil data pengajuan');
    }
    setLoading(false);
  }, [startDate, endDate]);

  useEffect(() => {
    fetchDataPengajuan();
  }, [fetchDataPengajuan]);

  useEffect(() => {
    if (activeTab === 'pengajuan') {
      fetchDataPengajuan();
    }
  }, [activeTab, fetchDataPengajuan]);

  const fetchDataBarang = useCallback(async (targetPage = barangCurrentPage) => {
    setLoading(true);
    try {
      let url = `/item-deletions/histori-barang?limit=${barangItemsPerPage}&page=${targetPage}`;
      if (statusFilter) {
        url += `&status=${encodeURIComponent(statusFilter)}`;
      }
      if (cabangFilter) {
        url += `&cabang=${encodeURIComponent(cabangFilter)}`;
      }
      if (operatorFilter) {
        url += `&operator=${encodeURIComponent(operatorFilter)}`;
      }
      if (searchQuery.trim()) {
        url += `&search=${encodeURIComponent(searchQuery.trim())}`;
      }
      if (startDate && endDate) {
        url += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(endDate).format('YYYY-MM-DD')}`;
      }
      const res = await http.get(url, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      const paginator = res.data.data;
      setBarangData(paginator?.data || []);
      setTotalBarangPages(paginator?.last_page || 1);
      setTotalBarangItems(paginator?.total || 0);
      setBarangFrom(paginator?.from || 0);
      setBarangTo(paginator?.to || 0);
    } catch (err) {
      console.log(err);
      toast.error('Gagal mengambil data histori barang');
    }
    setLoading(false);
  }, [barangCurrentPage, barangItemsPerPage, statusFilter, cabangFilter, operatorFilter, searchQuery, startDate, endDate]);

  useEffect(() => {
    if (activeTab === 'barang') {
      const timer = setTimeout(() => {
        fetchDataBarang(barangCurrentPage);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [activeTab, barangCurrentPage, statusFilter, cabangFilter, operatorFilter, searchQuery, startDate, endDate, fetchDataBarang]);

  const handlePersetujuan = async (id, action, catatan = '') => {
    setLoading(true);
    try {
      const payload = { action };
      if (catatan) payload.catatan = catatan;
      await http.post(
        `/item-deletions/${id}/persetujuan`,
        payload,
        { headers: { Authorization: getAuthorizationHeader() } }
      );
      toast.success(
        action === 'approve'
          ? 'Pengajuan disetujui, barang berhasil dihapus'
          : action === 'cancel'
          ? 'Pengajuan dibatalkan'
          : 'Pengajuan ditolak, barang dikembalikan ke etalase'
      );
      fetchDataPengajuan();
    } catch (err) {
      console.log(err);
      toast.error(err.response?.data?.message || 'Gagal memproses persetujuan');
    }
    setLoading(false);
  };

  function checkBerat(number) {
    const beratConfirm = parseFloat(number || 0);
    return beratConfirm % 1 === 0
      ? beratConfirm.toString()
      : beratConfirm
          .toFixed(2)
          .replace(/\.?0+$/, '')
          .replace('.', ',');
  }

  function showDetailItem(item) {
    setDetailItem(item);
    setOpenDetail(true);
  }

  const handleResetFilter = () => {
    setStartDate(null);
    setEndDate(null);
    setStatusFilter('');
    setCabangFilter('');
    setOperatorFilter('');
    setSearchQuery('');
    setCurrentPage(1);
    setBarangCurrentPage(1);
    setIsDateOpen(false);
  };

  const handleReload = () => {
    if (activeTab === 'pengajuan') {
      fetchDataPengajuan();
    } else {
      fetchDataBarang(barangCurrentPage);
    }
  };

  const activeFilters = useMemo(() => {
    const list = [];
    if (startDate && endDate) {
      list.push({
        id: 'date',
        label: `${moment(startDate).format('DD MMM YYYY')} - ${moment(endDate).format('DD MMM YYYY')}`,
        icon: '📅',
        onClear: () => {
          setStartDate(null);
          setEndDate(null);
          setCurrentPage(1);
          setBarangCurrentPage(1);
        },
      });
    }
    if (statusFilter) {
      const statusMap = {
        pending_approval: 'Menunggu',
        approved: 'Disetujui',
        rejected: 'Ditolak',
        cancelled: 'Dibatalkan',
      };
      list.push({
        id: 'status',
        label: statusMap[statusFilter] || statusFilter,
        icon: '⚡',
        onClear: () => {
          setStatusFilter('');
          setCurrentPage(1);
          setBarangCurrentPage(1);
        },
      });
    }
    if (cabangFilter) {
      list.push({
        id: 'cabang',
        label: `Cabang: ${cabangFilter}`,
        icon: '🏪',
        onClear: () => {
          setCabangFilter('');
          setCurrentPage(1);
          setBarangCurrentPage(1);
        },
      });
    }
    if (operatorFilter) {
      list.push({
        id: 'operator',
        label: `Operator: ${operatorFilter}`,
        icon: '👤',
        onClear: () => {
          setOperatorFilter('');
          setCurrentPage(1);
          setBarangCurrentPage(1);
        },
      });
    }
    return list;
  }, [startDate, endDate, statusFilter, cabangFilter, operatorFilter]);

  const activeFilterCount = activeFilters.length;

  // Options for Cabang and Operator from data
  const cabangOptions = useMemo(() => {
    const list = new Set();
    data.forEach((d) => {
      if (d.cabang?.nama_cabang) list.add(d.cabang.nama_cabang);
    });
    barangData.forEach((b) => {
      const cName = b.pengajuan?.cabang?.nama_cabang || b.item?.cabang?.nama_cabang;
      if (cName) list.add(cName);
    });
    return Array.from(list);
  }, [data, barangData]);

  const operatorOptions = useMemo(() => {
    const list = new Set();
    data.forEach((d) => {
      const name = d.diajukan_oleh?.name || d.user_pemohon?.name;
      if (name) list.add(name);
    });
    barangData.forEach((b) => {
      const name = b.pengajuan?.diajukan_oleh?.name || b.pengajuan?.user_pemohon?.name;
      if (name) list.add(name);
    });
    return Array.from(list);
  }, [data, barangData]);

  // Filtered Data based on dropdowns & search query
  const filteredData = useMemo(() => {
    return data.filter((item) => {
      if (statusFilter) {
        if (statusFilter === 'approved' && item.status_pengajuan !== 'direct_deleted' && item.status_pengajuan !== 'approved') {
          return false;
        } else if (statusFilter === 'cancelled' && item.status_pengajuan !== 'dibatalkan' && item.status_pengajuan !== 'cancelled') {
          return false;
        } else if (statusFilter !== 'approved' && statusFilter !== 'cancelled' && item.status_pengajuan !== statusFilter) {
          return false;
        }
      }
      if (cabangFilter && item.cabang?.nama_cabang !== cabangFilter) {
        return false;
      }
      if (operatorFilter) {
        const name = item.diajukan_oleh?.name || item.user_pemohon?.name;
        if (name !== operatorFilter) return false;
      }
      if (searchQuery.trim()) {
        const q = searchQuery.toLowerCase();
        const batch = item.batch_id ? item.batch_id.toLowerCase() : '';
        const pemohon = item.diajukan_oleh?.name ? item.diajukan_oleh.name.toLowerCase() : '';
        const cabang = item.cabang?.nama_cabang ? item.cabang.nama_cabang.toLowerCase() : '';
        if (!batch.includes(q) && !pemohon.includes(q) && !cabang.includes(q)) {
          return false;
        }
      }
      return true;
    });
  }, [data, statusFilter, cabangFilter, operatorFilter, searchQuery]);

  // Pagination for Pengajuan Table
  const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;
  const paginatedData = useMemo(() => {
    return filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  }, [filteredData, currentPage, itemsPerPage]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleBarangPageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalBarangPages) {
      setBarangCurrentPage(newPage);
    }
  };

  // Open Detail Modal Helper
  const handleOpenDetailModal = (pengajuan, defaultTab = 'ringkasan') => {
    setSelectedPengajuan(pengajuan);
    setModalTab(defaultTab);
    setSearchModalItem('');
    setIsOpenDetailModal(true);
  };

  // Helper to render Status Badge exactly like the image
  const renderStatus = (status) => {
    if (status === 'pending_approval' || status === 'pending') {
      return (
        <span className="px-2.5 py-1 rounded border border-amber-500 text-amber-600 bg-amber-50/50 text-[11px] font-bold">
          Menunggu
        </span>
      );
    }
    if (status === 'approved' || status === 'direct_deleted') {
      return (
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded border border-emerald-300 bg-emerald-100 text-emerald-700 text-[11px] font-bold">
          <IconCheck size={14} stroke={3} /> Disetujui
        </span>
      );
    }
    if (status === 'rejected') {
      return (
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded border border-red-300 bg-red-100 text-red-700 text-[11px] font-bold">
          <IconX size={14} stroke={3} /> Ditolak
        </span>
      );
    }
    if (status === 'cancelled' || status === 'dibatalkan') {
      return (
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded border border-slate-300 bg-slate-100 text-slate-700 text-[11px] font-bold">
          <IconX size={14} stroke={3} /> Dibatalkan
        </span>
      );
    }
    return <span>{status}</span>;
  };

  if (!isVerifikasi && !isOperatorToko) {
    return null;
  }

  return (
    <Layouts title="Pengajuan Hapus">
      <DetailItem
        checkBerat={checkBerat}
        detailItem={detailItem}
        closeModalDetail={() => setOpenDetail(false)}
        openDetail={openDetail}
      />

      <div className="p-4 sm:p-6 w-full space-y-6 min-h-[75vh]">
        {/* Modern Filter Toolbar */}
        <div className="bg-white dark:bg-slate-900 p-3 sm:p-4 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 space-y-3">
          {/* Row 1: Search & Action Buttons */}
          <div className="flex items-center gap-1.5 sm:gap-2 w-full">
            {/* Dominant Search Input */}
            <div className="relative flex-1 min-w-0">
              <IconSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                  setBarangCurrentPage(1);
                }}
                placeholder="Cari No. Request, Pemohon, Toko, Barang..."
                className="w-full pl-9 pr-8 py-2 text-xs sm:text-sm bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-slate-800 dark:text-slate-100 placeholder-slate-400 outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all shadow-xs"
              />
              {searchQuery && (
                <button
                  type="button"
                  onClick={() => {
                    setSearchQuery('');
                    setCurrentPage(1);
                    setBarangCurrentPage(1);
                  }}
                  className="absolute right-2.5 top-1/2 -translate-y-1/2 p-0.5 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 rounded-full cursor-pointer"
                  title="Hapus pencarian"
                >
                  <IconX size={14} />
                </button>
              )}
            </div>

            {/* Filter Toggle Button */}
            <button
              type="button"
              onClick={() => setIsFilterOpen(true)}
              className={`flex items-center gap-1.5 px-2.5 sm:px-3 py-2 rounded-lg text-xs sm:text-sm font-semibold border transition-all shrink-0 cursor-pointer shadow-xs ${
                activeFilterCount > 0
                  ? 'bg-amber-500 border-amber-600 text-white shadow-amber-500/20'
                  : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-600 text-slate-700 dark:text-slate-200 hover:border-amber-300 dark:hover:border-amber-500'
              }`}
              title="Buka Filter"
            >
              <IconAdjustmentsHorizontal size={16} />
              <span className="hidden sm:inline">Filter</span>
              {activeFilterCount > 0 && (
                <span className="px-1.5 py-0.2 text-[10px] font-bold rounded-full leading-tight bg-white text-amber-700">
                  {activeFilterCount}
                </span>
              )}
            </button>

            {/* Reload / Refresh Button */}
            <button
              type="button"
              onClick={handleReload}
              className="bg-slate-700 hover:bg-slate-800 text-white p-2 cursor-pointer rounded-lg shadow-xs hover:shadow transition-all duration-200 shrink-0"
              title="Muat Ulang Data"
            >
              <IconReload size={18} className={loading ? 'animate-spin' : ''} />
            </button>
          </div>

          {/* Row 2: Active Filter Chips Bar */}
          {activeFilterCount > 0 && (
            <div className="flex items-center gap-1.5 overflow-x-auto py-1 w-full max-w-full no-scrollbar text-xs">
              <span className="text-[11px] font-semibold text-slate-400 dark:text-slate-500 shrink-0 uppercase tracking-wider">
                Filter:
              </span>
              {activeFilters.map((flt) => (
                <div
                  key={flt.id}
                  className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 text-amber-800 dark:text-amber-300 font-medium whitespace-nowrap shadow-2xs shrink-0"
                >
                  <span className="text-xs">{flt.icon}</span>
                  <span className="max-w-[150px] sm:max-w-[200px] truncate">{flt.label}</span>
                  <button
                    type="button"
                    onClick={flt.onClear}
                    className="p-0.5 hover:bg-amber-200/60 dark:hover:bg-amber-800/60 rounded-full transition-colors ml-0.5 cursor-pointer text-amber-600 dark:text-amber-400"
                    title={`Hapus filter ${flt.label}`}
                  >
                    <IconX size={12} />
                  </button>
                </div>
              ))}

              <button
                type="button"
                onClick={handleResetFilter}
                className="text-[11px] font-bold text-rose-600 dark:text-rose-400 hover:underline px-2 py-0.5 rounded shrink-0 cursor-pointer whitespace-nowrap"
              >
                Reset Semua
              </button>
            </div>
          )}
        </div>

        {/* ═══ Filter Slide-over Drawer (Muncul dari Kanan Layar) ═══ */}
        <Transition appear show={isFilterOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-[99999]"
            onClose={() => setIsFilterOpen(false)}
          >
            {/* Backdrop Overlay Tipis */}
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-slate-900/20 dark:bg-black/40 pointer-events-auto" />
            </Transition.Child>

            {/* Drawer Container */}
            <div className="fixed inset-0 overflow-hidden pointer-events-none">
              <div className="fixed inset-y-0 right-0 flex max-w-full pl-0 sm:pl-10">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-300 sm:duration-400"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-300 sm:duration-400"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-[340px] sm:max-w-[420px] md:max-w-[460px] transform bg-white dark:bg-slate-900 shadow-2xl border-l border-slate-200 dark:border-slate-800 text-left align-middle transition-all flex flex-col h-screen max-h-screen">
                    {/* Drawer Header */}
                    <div className="px-5 py-4 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 flex items-center justify-between shrink-0 sticky top-0 z-20">
                      <div className="flex items-center gap-2.5">
                        <div className="p-2 rounded-xl bg-amber-500/10 text-amber-600 dark:text-amber-400">
                          <IconAdjustmentsHorizontal size={20} />
                        </div>
                        <div>
                          <Dialog.Title as="h2" className="text-base font-bold text-slate-800 dark:text-slate-100">
                            Filter Pengajuan Hapus
                          </Dialog.Title>
                          <p className="text-xs text-slate-500 dark:text-slate-400">
                            {activeFilterCount > 0
                              ? `${activeFilterCount} kriteria aktif`
                              : 'Atur filter data pengajuan'}
                          </p>
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={() => setIsFilterOpen(false)}
                        className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800 transition cursor-pointer"
                      >
                        <IconX size={18} />
                      </button>
                    </div>

                    {/* Drawer Body (Scrollable) */}
                    <div className="p-5 flex-1 overflow-y-auto space-y-5">
                      {/* 1. Filter Tanggal Pengajuan */}
                      <div>
                        <div className="flex items-center justify-between mb-2">
                          <label className="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider">
                            Rentang Tanggal
                          </label>
                          {startDate && (
                            <button
                              type="button"
                              onClick={() => {
                                setStartDate(null);
                                setEndDate(null);
                                setIsDateOpen(false);
                                setCurrentPage(1);
                                setBarangCurrentPage(1);
                              }}
                              className="text-xs font-bold text-rose-500 hover:underline cursor-pointer"
                            >
                              Reset Tanggal
                            </button>
                          )}
                        </div>

                        <button
                          type="button"
                          onClick={() => setIsDateOpen((prev) => !prev)}
                          className={`w-full h-11 border rounded-xl px-3.5 flex items-center justify-between transition-all cursor-pointer text-xs sm:text-sm font-medium ${
                            isDateOpen
                              ? 'border-amber-500 ring-2 ring-amber-500/20 bg-amber-50/40 dark:bg-amber-950/20 text-amber-700 dark:text-amber-300'
                              : startDate && endDate
                              ? 'border-amber-400 bg-amber-50/20 dark:bg-amber-950/10 text-slate-800 dark:text-slate-100'
                              : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:border-amber-400'
                          }`}
                        >
                          <div className="flex items-center gap-2 overflow-hidden">
                            <IconCalendarTime size={18} className="text-amber-500 shrink-0" />
                            <span className="truncate">
                              {startDate && endDate
                                ? `${moment(startDate).format('DD/MM/YYYY')} - ${moment(endDate).format('DD/MM/YYYY')}`
                                : 'Pilih Rentang Tanggal'}
                            </span>
                          </div>
                          <span className="text-xs text-slate-400 font-semibold shrink-0 ml-2">
                            {isDateOpen ? 'Tutup ▲' : 'Buka ▼'}
                          </span>
                        </button>

                        {isDateOpen && (
                          <div className="mt-2.5 border border-slate-200 dark:border-slate-700 rounded-xl overflow-hidden p-2 flex flex-col items-center bg-white dark:bg-slate-800 shadow-sm animate-in fade-in duration-150">
                            <DateRange
                              ranges={[selectionRange]}
                              onChange={handleSelectDate}
                              rangeColors={['#f59e0b']}
                              months={1}
                              direction="horizontal"
                              showDateDisplay={false}
                              moveRangeOnFirstSelection={false}
                            />
                            <div className="w-full flex items-center justify-between pt-2 border-t border-slate-100 dark:border-slate-700 mt-1 px-1">
                              <span className="text-xs text-slate-400">
                                {startDate && endDate ? `${moment(startDate).format('DD/MM/YY')} - ${moment(endDate).format('DD/MM/YY')}` : 'Pilih rentang tanggal'}
                              </span>
                              <button
                                type="button"
                                onClick={() => setIsDateOpen(false)}
                                className="px-3 py-1 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-xs font-bold transition cursor-pointer"
                              >
                                Terapkan
                              </button>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* 2. Filter Status Pengajuan */}
                      <div>
                        <label className="block text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider mb-2">
                          Status Pengajuan
                        </label>
                        <select
                          value={statusFilter}
                          onChange={(e) => {
                            setStatusFilter(e.target.value);
                            setCurrentPage(1);
                            setBarangCurrentPage(1);
                          }}
                          className="w-full h-11 border border-slate-200 dark:border-slate-700 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-400 dark:hover:border-amber-500 outline-none font-medium shadow-xs"
                        >
                          <option value="">Semua Status</option>
                          <option value="pending_approval">Menunggu Persetujuan</option>
                          <option value="approved">Disetujui</option>
                          <option value="rejected">Ditolak</option>
                          <option value="cancelled">Dibatalkan</option>
                        </select>
                      </div>

                      {/* 3. Cabang Asal Filter */}
                      <div>
                        <label className="block text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider mb-2">
                          Cabang Asal
                        </label>
                        <select
                          value={cabangFilter}
                          onChange={(e) => {
                            setCabangFilter(e.target.value);
                            setCurrentPage(1);
                            setBarangCurrentPage(1);
                          }}
                          className="w-full h-11 border border-slate-200 dark:border-slate-700 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-400 dark:hover:border-amber-500 outline-none font-medium shadow-xs"
                        >
                          <option value="">Semua Cabang</option>
                          {cabangOptions.map((c, i) => (
                            <option key={i} value={c}>
                              {c}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* 4. Operator Filter */}
                      <div>
                        <label className="block text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider mb-2">
                          Operator Pemohon
                        </label>
                        <select
                          value={operatorFilter}
                          onChange={(e) => {
                            setOperatorFilter(e.target.value);
                            setCurrentPage(1);
                            setBarangCurrentPage(1);
                          }}
                          className="w-full h-11 border border-slate-200 dark:border-slate-700 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-400 dark:hover:border-amber-500 outline-none font-medium shadow-xs"
                        >
                          <option value="">Semua Operator</option>
                          {operatorOptions.map((op, i) => (
                            <option key={i} value={op}>
                              {op}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Drawer Footer (Sticky Bottom) */}
                    <div className="p-4 border-t border-slate-200 dark:border-slate-800 bg-slate-50/80 dark:bg-slate-900/80 flex items-center justify-between gap-3 shrink-0">
                      <button
                        type="button"
                        onClick={() => setIsFilterOpen(false)}
                        className="px-5 py-2.5 bg-amber-500 hover:bg-amber-600 text-white font-bold text-xs sm:text-sm rounded-xl shadow-sm transition cursor-pointer"
                      >
                        Terapkan & Tutup
                      </button>
                      {activeFilterCount > 0 && (
                        <button
                          type="button"
                          onClick={handleResetFilter}
                          className="px-3.5 py-2 text-xs font-bold text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-950/40 rounded-xl transition cursor-pointer"
                        >
                          Reset Filter
                        </button>
                      )}
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>

        {/* Tabel Data Pengajuan */}
        <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200/80 dark:border-slate-800">
          <div className="relative overflow-x-auto min-h-[380px]">
            <table className="w-full text-sm text-left dark:text-slate-300">
            <thead className="bg-gradient-to-r from-amber-50 via-amber-100/80 to-amber-50 dark:from-amber-900/30 dark:via-amber-800/20 dark:to-amber-900/30 border-b border-amber-200/60 dark:border-slate-700/60">
              <tr>
                <th scope="col" className="px-3.5 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                  No.
                </th>
                <th scope="col" className="px-3.5 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                  No. Request
                </th>
                <th scope="col" className="px-3.5 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                  Tgl Request
                </th>
                <th scope="col" className="px-3.5 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                  Tgl Terima
                </th>
                <th scope="col" className="px-3.5 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                  Cabang Asal
                </th>
                <th scope="col" className="px-3.5 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                  Pemohon
                </th>
                <th scope="col" className="px-3.5 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                  Verifikator
                </th>
                <th scope="col" className="px-3.5 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                  Total Barang
                </th>
                <th scope="col" className="px-3.5 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-center">
                  Status
                </th>
                <th scope="col" className="px-3.5 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-center">
                  Aksi Verifikasi
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-700/60 bg-white dark:bg-slate-900">
              {loading ? (
                <tr>
                  <td colSpan="10" className="py-20 text-center whitespace-nowrap">
                    <div className="flex flex-col items-center justify-center gap-3">
                      <div className="w-10 h-10 border-3 border-amber-200 dark:border-amber-800 border-t-amber-500 dark:border-t-amber-400 rounded-full animate-spin"></div>
                      <span className="text-sm font-medium text-slate-500 dark:text-slate-400">Memuat data pengajuan...</span>
                    </div>
                  </td>
                </tr>
              ) : paginatedData.length === 0 ? (
                <tr>
                  <td colSpan="10" className="py-20 text-center whitespace-nowrap">
                    <div className="flex flex-col items-center justify-center gap-2.5 text-slate-400 dark:text-slate-500">
                      <div className="w-12 h-12 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-500 flex items-center justify-center border border-amber-200/60 dark:border-amber-800/40">
                        <IconSearch size={24} />
                      </div>
                      <p className="text-sm font-semibold text-slate-700 dark:text-slate-200">
                        Tidak ada riwayat pengajuan hapus barang
                      </p>
                      <p className="text-xs text-slate-400 dark:text-slate-500 max-w-sm">
                        Tidak ditemukan data pengajuan yang sesuai dengan pencarian atau filter yang dipilih.
                      </p>
                    </div>
                  </td>
                </tr>
              ) : (
                paginatedData.map((pengajuan, idx) => {
                  const totalPcs = pengajuan.items?.length || 0;
                  const restoredCount = (pengajuan.items || []).filter((c) => c.status_item === 'restored').length;
                  const totalBerat =
                    pengajuan.items?.reduce(
                      (total, child) => total + parseFloat((child.item || child)?.berat || 0),
                      0
                    ) || 0;
                  const displayBerat = parseFloat(totalBerat).toFixed(3);
                  const isPending =
                    pengajuan.status_pengajuan === 'pending_approval' || pengajuan.status_pengajuan === 'pending';

                  return (
                    <tr
                      key={pengajuan.id}
                      onClick={() => handleOpenDetailModal(pengajuan, 'ringkasan')}
                      className="bg-white dark:bg-slate-900 hover:bg-slate-50 dark:hover:bg-slate-800/60 cursor-pointer border-b border-slate-100 dark:border-slate-800 transition-colors"
                    >
                      <td className="px-3.5 py-3 whitespace-nowrap font-normal text-slate-500 dark:text-slate-400">
                        {(currentPage - 1) * itemsPerPage + idx + 1}.
                      </td>
                      <td className="px-3.5 py-3 whitespace-nowrap font-mono font-bold text-amber-600 dark:text-amber-400">
                        {pengajuan.batch_id}
                      </td>
                      <td className="px-3.5 py-3 whitespace-nowrap text-slate-600 dark:text-slate-400">
                        {moment(pengajuan.created_at).format('DD MMM YYYY, HH.mm')}
                      </td>
                      <td className="px-3.5 py-3 whitespace-nowrap text-slate-600 dark:text-slate-400">
                        {pengajuan.status_pengajuan === 'approved' ||
                        pengajuan.status_pengajuan === 'rejected' ||
                        pengajuan.status_pengajuan === 'direct_deleted'
                          ? moment(pengajuan.updated_at).format('DD MMM YYYY, HH.mm')
                          : '-'}
                      </td>
                      <td className="px-3.5 py-3 whitespace-nowrap font-semibold text-slate-800 dark:text-slate-200">
                        {pengajuan.cabang?.nama_cabang || '-'}
                      </td>
                      <td className="px-3.5 py-3 whitespace-nowrap text-slate-700 dark:text-slate-300">
                        {pengajuan.diajukan_oleh?.name || pengajuan.user_pemohon?.name || 'Sistem'}
                      </td>
                      <td className="px-3.5 py-3 whitespace-nowrap font-semibold text-emerald-600 dark:text-emerald-400">
                        {pengajuan.disetujui_oleh?.name || pengajuan.user_verifikator?.name || '-'}
                      </td>
                      <td className="px-3.5 py-3 whitespace-nowrap font-bold text-slate-800 dark:text-slate-100">
                        {totalPcs} PCS <span className="font-semibold text-slate-500">({displayBerat} gr)</span>
                      </td>
                      <td className="px-3.5 py-3 whitespace-nowrap text-center">
                        <div className="flex flex-col items-center gap-1">
                          {renderStatus(pengajuan.status_pengajuan)}
                          {restoredCount > 0 && (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-100 text-emerald-800 dark:bg-emerald-950/70 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-700">
                              <IconRotateClockwise size={11} />
                              {restoredCount === totalPcs ? 'Semua Dikembalikan' : `${restoredCount}/${totalPcs} Dikembalikan`}
                            </span>
                          )}
                        </div>
                      </td>
                      <td className="px-3.5 py-3 whitespace-nowrap text-center" onClick={(e) => e.stopPropagation()}>
                        <div className="flex items-center justify-center gap-1.5">
                          {isVerifikasi && isPending && canVerify ? (
                            <>
                              <button
                                onClick={() => confirmAction(pengajuan.id, 'approve')}
                                className="px-2.5 py-1 bg-emerald-50 text-emerald-600 border border-emerald-200 rounded hover:bg-emerald-100 flex items-center gap-1 font-medium transition-colors text-xs cursor-pointer"
                                title="Setujui Pengajuan"
                              >
                                <IconCheck size={14} /> Terima
                              </button>
                              <button
                                onClick={() => confirmAction(pengajuan.id, 'reject')}
                                className="px-2.5 py-1 bg-red-50 text-red-600 border border-red-200 rounded hover:bg-red-100 flex items-center gap-1 font-medium transition-colors text-xs cursor-pointer"
                                title="Tolak Pengajuan"
                              >
                                <IconX size={14} /> Tolak
                              </button>
                            </>
                          ) : !isVerifikasi && isPending && !canVerify ? (
                            <button
                              onClick={() => confirmAction(pengajuan.id, 'cancel')}
                              className="px-2.5 py-1 bg-slate-50 text-slate-600 border border-slate-200 rounded hover:bg-slate-100 flex items-center gap-1 font-medium transition-colors text-xs cursor-pointer"
                              title="Batalkan Pengajuan"
                            >
                              <IconX size={14} /> Batalkan
                            </button>
                          ) : null}
                          <button
                            type="button"
                            onClick={() => handleOpenDetailModal(pengajuan, 'ringkasan')}
                            className="text-amber-500 hover:text-amber-600 p-1.5 hover:bg-amber-50 dark:hover:bg-amber-900/30 rounded-lg transition-colors cursor-pointer"
                            title="Lihat Detail Permohonan"
                          >
                            <IconEye size={18} stroke={2.5} />
                          </button>
                          <button
                            type="button"
                            onClick={() => handleOpenDetailModal(pengajuan, 'galeri')}
                            className="text-amber-500 hover:text-amber-600 p-1.5 bg-amber-50 dark:bg-amber-900/30 rounded-lg border border-amber-200/60 dark:border-amber-800 hover:bg-amber-100 transition-colors cursor-pointer"
                            title="Lihat Galeri Foto"
                          >
                            <IconPhoto size={18} stroke={2.5} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/50">
              <span className="text-xs text-slate-500 dark:text-slate-400">
                Menampilkan {(currentPage - 1) * itemsPerPage + 1} -{' '}
                {Math.min(currentPage * itemsPerPage, filteredData.length)} dari {filteredData.length} pengajuan
              </span>
              <div className="flex items-center gap-1">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="px-2.5 py-1 text-xs font-medium border border-slate-200 dark:border-slate-700 rounded text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
                >
                  Prev
                </button>
                <span className="px-3 text-xs font-bold text-slate-700 dark:text-slate-200">
                  {currentPage} / {totalPages}
                </span>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="px-2.5 py-1 text-xs font-medium border border-slate-200 dark:border-slate-700 rounded text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Detail Items Slide-Over Drawer (Muncul dari Kanan Layar) */}
      <Transition appear show={isOpenDetailModal && Boolean(selectedPengajuan)} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-[9990]"
          onClose={() => setIsOpenDetailModal(false)}
        >
          {/* Backdrop Overlay */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-slate-900/20 dark:bg-black/40 pointer-events-auto" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden pointer-events-none">
            <div className="fixed inset-y-0 right-0 flex max-w-full pl-0 sm:pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-300 sm:duration-400"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300 sm:duration-400"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl xl:max-w-5xl transform bg-white dark:bg-slate-800 shadow-2xl border-l border-slate-200 dark:border-slate-700 text-left align-middle transition-all flex flex-col h-screen max-h-screen p-5 md:p-6 space-y-4">
                  {selectedPengajuan && (() => {
                    const userPemohon =
                      selectedPengajuan.diajukan_oleh ||
                      selectedPengajuan.user_pemohon ||
                      selectedPengajuan.userPemohon ||
                      selectedPengajuan.user;
                    const userVerifikator =
                      selectedPengajuan.disetujui_oleh ||
                      selectedPengajuan.user_verifikator ||
                      selectedPengajuan.userVerifikator;
                    const totalPcs = selectedPengajuan.items?.length || 0;
                    const totalBerat =
                      selectedPengajuan.items?.reduce(
                        (total, child) => total + parseFloat((child.item || child)?.berat || 0),
                        0
                      ) || 0;
                    const isPending =
                      selectedPengajuan.status_pengajuan === 'pending_approval' || selectedPengajuan.status_pengajuan === 'pending';
                    const isApproved =
                      selectedPengajuan.status_pengajuan === 'approved' ||
                      selectedPengajuan.status_pengajuan === 'direct_deleted';
                    const isCancelled =
                      selectedPengajuan.status_pengajuan === 'cancelled' ||
                      selectedPengajuan.status_pengajuan === 'dibatalkan';
                    const isRejected = selectedPengajuan.status_pengajuan === 'rejected';

                    return (
                      <>
                        {/* Modal Header */}
                        <div className="flex items-center justify-between border-b border-slate-100 dark:border-slate-700 pb-3 flex-shrink-0">
                          <div>
                            <div className="flex items-center gap-2">
                              <Dialog.Title as="h3" className="font-bold text-sm md:text-base text-slate-800 dark:text-slate-100">
                                Detail Permohonan: <span className="font-mono text-amber-600">{selectedPengajuan.batch_id}</span>
                              </Dialog.Title>
                              {isPending ? (
                                <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-amber-100 text-amber-700 dark:bg-amber-950/60 dark:text-amber-300 rounded-md border border-amber-300 dark:border-amber-700 text-[11px] font-bold">
                                  Menunggu
                                </span>
                              ) : isApproved ? (
                                <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-emerald-100 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300 rounded-md border border-emerald-300 dark:border-emerald-700 text-[11px] font-bold">
                                  ✓ Disetujui
                                </span>
                              ) : isCancelled ? (
                                <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 rounded-md border border-slate-300 text-[11px] font-bold">
                                  Dibatalkan
                                </span>
                              ) : (
                                <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-rose-100 text-rose-700 dark:bg-rose-950/60 dark:text-rose-300 rounded-md border border-rose-300 dark:border-rose-700 text-[11px] font-bold">
                                  ✕ Ditolak
                                </span>
                              )}
                            </div>
                            <div className="flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-slate-500 mt-1">
                              <span>
                                <strong className="text-slate-600 dark:text-slate-400">Request:</strong>{' '}
                                {new Date(selectedPengajuan.created_at).toLocaleString('id-ID', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                })}
                              </span>
                              {!isPending && selectedPengajuan.updated_at && (
                                <span>
                                  <strong className="text-slate-600 dark:text-slate-400">Verifikasi:</strong>{' '}
                                  {new Date(selectedPengajuan.updated_at).toLocaleString('id-ID', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                  })}
                                </span>
                              )}
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => setIsOpenDetailModal(false)}
                            className="p-1.5 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors cursor-pointer"
                          >
                            <IconX size={20} />
                          </button>
                        </div>

                        {/* Top Quick Info Strip */}
                        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-xs bg-slate-50 dark:bg-slate-700/40 p-3 rounded-xl flex-shrink-0">
                <div>
                  <span className="text-slate-400 block text-[10px]">Toko Asal (Etalase)</span>
                  <span className="font-bold text-slate-800 dark:text-slate-200 truncate block">
                    {selectedPengajuan.cabang?.nama_cabang || '-'}
                  </span>
                </div>
                <div>
                  <span className="text-slate-400 block text-[10px]">Operator Pemohon</span>
                  <span className="font-bold text-slate-800 dark:text-slate-200 truncate block">
                    {userPemohon?.name || 'Sistem'}
                  </span>
                </div>
                <div>
                  <span className="text-slate-400 block text-[10px]">Total Item & Berat</span>
                  <span className="font-bold text-slate-800 dark:text-slate-200 truncate block">
                    {totalPcs} PCS
                    <span className="text-amber-600 dark:text-amber-400 font-semibold ml-1">
                      ({parseFloat(totalBerat).toFixed(3)} gr)
                    </span>
                  </span>
                </div>
                <div>
                  <span className="text-slate-400 block text-[10px]">Verifikator</span>
                  <span className="font-bold text-emerald-600 dark:text-emerald-400 truncate block">
                    {userVerifikator?.name ||
                      (isPending ? 'Menunggu...' : isCancelled ? 'Dibatalkan' : '-')}
                  </span>
                </div>
              </div>

              {/* 5 Tab Navigation Bar */}
              <div className="flex border-b border-slate-200 dark:border-slate-700 gap-1 overflow-x-auto scrollbar-none flex-shrink-0">
                <button
                  type="button"
                  onClick={() => setModalTab('ringkasan')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'ringkasan'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconChartPie size={16} />
                  <span>Ringkasan Item</span>
                </button>
                <button
                  type="button"
                  onClick={() => setModalTab('list')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'list'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconListDetails size={16} />
                  <span>List Item ({modalItemList.length})</span>
                </button>
                <button
                  type="button"
                  onClick={() => setModalTab('operator')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'operator'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconUser size={16} />
                  <span>Operator Pemohon</span>
                </button>
                <button
                  type="button"
                  onClick={() => setModalTab('verifikator')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'verifikator'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconCircleCheck size={16} />
                  <span>Verifikator</span>
                </button>
                <button
                  type="button"
                  onClick={() => setModalTab('galeri')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'galeri'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconPhoto size={16} />
                  <span>Galeri List Item</span>
                </button>
              </div>

              {/* Scrollable Tab Content */}
              <div className="flex-1 overflow-y-auto pr-1">
                {/* 1. Tab Ringkasan Item */}
                {modalTab === 'ringkasan' && (() => {
                  const itemsList = selectedPengajuan.items || [];
                  const totalPcsVal = totalPcs || itemsList.length;
                  const totalBeratVal = parseFloat(totalBerat || itemsList.reduce((acc, it) => acc + parseFloat((it.item || it)?.berat || 0), 0));
                  const avgBeratVal = itemsList.length > 0 ? (totalBeratVal / itemsList.length) : (totalPcsVal > 0 ? totalBeratVal / totalPcsVal : 0);
                  const validModalItems = itemsList.filter(it => Number((it.item || it)?.harga_modal || 0) > 0);
                  const avgModalVal = validModalItems.length > 0
                    ? Math.round(validModalItems.reduce((acc, it) => acc + Number((it.item || it)?.harga_modal || 0), 0) / validModalItems.length)
                    : 0;
                  const maxBeratVal = itemsList.length > 0 ? Math.max(...itemsList.map(it => parseFloat((it.item || it)?.berat || 0) || 0)) : 0;
                  const maxModalVal = itemsList.length > 0 ? Math.max(...itemsList.map(it => Number((it.item || it)?.harga_modal || 0) || 0)) : 0;

                  return (
                    <div className="space-y-4">
                      {/* Ringkasan Cards (7 Cards) */}
                      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2.5 sm:gap-3">
                        <div className="bg-amber-50/60 dark:bg-amber-950/20 border border-amber-200/70 dark:border-amber-900/40 rounded-xl p-3">
                          <span className="text-amber-700 dark:text-amber-400 text-[10px] font-bold uppercase tracking-wider block">Total Barang</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5">
                            {totalPcsVal} <span className="text-xs font-semibold text-slate-500">Pcs</span>
                          </div>
                        </div>
                        <div className="bg-amber-50/60 dark:bg-amber-950/20 border border-amber-200/70 dark:border-amber-900/40 rounded-xl p-3">
                          <span className="text-amber-700 dark:text-amber-400 text-[10px] font-bold uppercase tracking-wider block">Total Berat</span>
                          <div className="text-lg font-extrabold text-amber-600 dark:text-amber-400 mt-0.5 font-mono">
                            {totalBeratVal.toFixed(3)} <span className="text-xs font-semibold text-slate-500 font-sans">gr</span>
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Total Kategori</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5">
                            {Object.keys(detailSummary).length} <span className="text-xs font-semibold text-slate-500">Kategori</span>
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Rata-rata Berat</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                            {avgBeratVal.toFixed(3)} <span className="text-xs font-semibold text-slate-500 font-sans">gr</span>
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Rata-rata Modal</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                            Rp {avgModalVal.toLocaleString('id-ID')}
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Berat Maksimal</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                            {maxBeratVal.toFixed(3)} <span className="text-xs font-semibold text-slate-500 font-sans">gr</span>
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Modal Maksimal</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                            Rp {maxModalVal.toLocaleString('id-ID')}
                          </div>
                        </div>
                      </div>

                    {/* Breakdown Kategori & Karat */}
                    {Object.keys(detailSummary).length > 0 && (
                      <div className="space-y-3 p-3.5 bg-amber-50/50 dark:bg-amber-900/10 border border-amber-200/50 dark:border-amber-900/30 rounded-xl">
                        <div className="flex items-center justify-between">
                          <h4 className="text-[11px] font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider flex items-center gap-1.5">
                            <IconChartPie size={16} />
                            <span>Breakdown Per Kategori & Karat</span>
                          </h4>
                          <span className="text-[10px] text-amber-700 dark:text-amber-400 font-semibold">
                            {Object.keys(detailSummary).length} Kategori
                          </span>
                        </div>
                        <div className="space-y-2">
                          {Object.values(detailSummary).map((cat, idx) => (
                            <div
                              key={idx}
                              className="bg-white dark:bg-slate-800 p-3 rounded-xl border border-amber-200/60 dark:border-slate-700 shadow-sm"
                            >
                              <div className="flex justify-between items-center mb-2 pb-2 border-b border-slate-100 dark:border-slate-700">
                                <span className="font-bold text-slate-800 dark:text-slate-100 text-sm">{cat.name}</span>
                                <span className="font-bold text-amber-600 dark:text-amber-400 text-xs bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-800 px-2.5 py-0.5 rounded-md">
                                  {cat.pcs} Pcs ({cat.berat.toFixed(3)} gr)
                                </span>
                              </div>
                              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                                {Object.entries(cat.byKarat).map(([karat, val], i) => (
                                  <div
                                    key={i}
                                    className="flex items-center justify-between bg-slate-50 dark:bg-slate-700/40 px-2.5 py-1.5 rounded-lg text-xs border border-slate-100 dark:border-slate-700"
                                  >
                                    <span className="font-semibold text-slate-500 dark:text-slate-400">
                                      {karat} Karat
                                    </span>
                                    <span className="font-bold text-slate-800 dark:text-slate-100">
                                      {val.pcs} Pcs / {val.berat.toFixed(3)}g
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Catatan Area */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-1">
                      <div className="p-3 bg-slate-50 dark:bg-slate-700/30 rounded-xl border border-slate-200 dark:border-slate-700 space-y-1">
                        <span className="text-slate-400 text-[10px] font-bold uppercase tracking-wider block">
                          Alasan Pengajuan Hapus (Pemohon)
                        </span>
                        <p className="text-xs text-slate-700 dark:text-slate-300 font-medium leading-relaxed">
                          {selectedPengajuan.alasan || (
                            <span className="italic text-slate-400">Tidak ada catatan alasan dari pemohon.</span>
                          )}
                        </p>
                      </div>
                      <div className="p-3 bg-slate-50 dark:bg-slate-700/30 rounded-xl border border-slate-200 dark:border-slate-700 space-y-1">
                        <span className="text-slate-400 text-[10px] font-bold uppercase tracking-wider block">
                          {isCancelled ? 'Alasan Pembatalan' : 'Catatan Verifikator'}
                        </span>
                        <p className="text-xs text-slate-700 dark:text-slate-300 font-medium leading-relaxed">
                          {(
                            selectedPengajuan.catatan_verifikasi ||
                            selectedPengajuan.catatan_verifikator ||
                            selectedPengajuan.catatan
                          ) ? (
                            selectedPengajuan.catatan_verifikasi ||
                            selectedPengajuan.catatan_verifikator ||
                            selectedPengajuan.catatan
                          ) : (
                            <span className="italic text-slate-400">
                              {isPending
                                ? 'Menunggu pemeriksaan verifikator...'
                                : isCancelled
                                ? 'Permohonan dibatalkan oleh pemohon.'
                                : 'Tidak ada catatan atau instruksi khusus dari verifikator.'}
                            </span>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })()}

                {/* 2. Tab List Item (Tabel) */}
                {modalTab === 'list' && (() => {
                  const isApprovedPengajuan =
                    selectedPengajuan.status_pengajuan === 'approved' ||
                    selectedPengajuan.status_pengajuan === 'direct_deleted';
                  const unRestoredItems = modalItemList.filter((it) => it.status_item !== 'restored');

                  return (
                    <div className="space-y-3">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                        <div className="relative flex-1 max-w-xs">
                          <IconSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={15} />
                          <input
                            type="text"
                            placeholder="Cari kode, jenis, baki..."
                            value={searchModalItem}
                            onChange={(e) => setSearchModalItem(e.target.value)}
                            className="w-full pl-8 pr-3 py-1.5 text-xs bg-slate-50 dark:bg-slate-700/50 border border-slate-200 dark:border-slate-600 rounded-lg outline-none focus:border-amber-400 focus:ring-1 focus:ring-amber-200"
                          />
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-[11px] text-slate-500 font-medium">
                            Menampilkan {filteredModalItems.length} dari {modalItemList.length} item
                          </span>
                          {isApprovedPengajuan && canVerify && unRestoredItems.length > 0 && (
                            <button
                              type="button"
                              onClick={() => handleOpenRestoreModal(selectedPengajuan, [])}
                              className="px-3 py-1.5 text-xs font-bold text-white bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-500 hover:to-teal-500 rounded-xl shadow-xs transition-all flex items-center gap-1.5 cursor-pointer shrink-0"
                              title="Kembalikan semua barang terhapus di pengajuan ini ke etalase toko"
                            >
                              <IconRotateClockwise size={14} />
                              <span>Kembalikan Semua ({unRestoredItems.length})</span>
                            </button>
                          )}
                        </div>
                      </div>

                      <div className="border border-slate-200 dark:border-slate-700 rounded-xl overflow-x-auto max-h-80">
                        <table className="w-full text-xs text-left text-slate-600 dark:text-slate-300">
                          <thead className="bg-gradient-to-r from-amber-50 via-amber-100/80 to-amber-50 dark:from-amber-900/40 dark:via-amber-800/30 dark:to-amber-900/40 text-[11px] text-amber-800 dark:text-amber-300 uppercase border-b border-amber-200/70 dark:border-amber-800/40 sticky top-0 z-10 font-bold tracking-wider">
                            <tr>
                              <th className="p-2.5 w-10 text-center font-bold whitespace-nowrap">No</th>
                              <th className="p-2.5 font-bold whitespace-nowrap">Kode Barang</th>
                              <th className="p-2.5 font-bold whitespace-nowrap">Nama Barang</th>
                              <th className="p-2.5 text-center font-bold whitespace-nowrap">Baki / Rak</th>
                              <th className="p-2.5 text-right font-bold whitespace-nowrap">Berat (gr)</th>
                              <th className="p-2.5 text-center font-bold whitespace-nowrap">Karat</th>
                              <th className="p-2.5 text-center font-bold whitespace-nowrap">Status</th>
                              {isApprovedPengajuan && canVerify && (
                                <th className="p-2.5 text-center font-bold whitespace-nowrap">Aksi</th>
                              )}
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                            {filteredModalItems.length === 0 ? (
                              <tr>
                                <td colSpan={isApprovedPengajuan && canVerify ? 8 : 7} className="text-center py-6 text-slate-400 whitespace-nowrap">
                                  Tidak ada item yang sesuai dengan pencarian
                                </td>
                              </tr>
                            ) : (
                              filteredModalItems.map((it, idx) => {
                                const isRestored = it.status_item === 'restored';
                                return (
                                  <tr
                                    key={it.id || idx}
                                    onClick={() => showDetailItem(it)}
                                    className="hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors cursor-pointer"
                                  >
                                    <td className="p-2.5 text-slate-500 font-medium text-center whitespace-nowrap">{idx + 1}.</td>
                                    <td className="p-2.5 font-mono font-bold text-amber-600 dark:text-amber-400 whitespace-nowrap">
                                      {it.kode_item}
                                    </td>
                                    <td className="p-2.5 whitespace-nowrap">
                                      <span className="text-slate-700 dark:text-slate-300 font-medium">
                                        {it.jenis_kategori?.nama_jenis || '-'}
                                      </span>
                                    </td>
                                    <td className="p-2.5 text-center font-medium whitespace-nowrap">{it.nomor_rak || '-'}</td>
                                    <td className="p-2.5 text-right font-bold text-amber-600 dark:text-amber-400 whitespace-nowrap">
                                      {parseFloat(it.berat || 0).toFixed(3)} gr
                                    </td>
                                    <td className="p-2.5 text-center font-semibold whitespace-nowrap">{it.karat} K</td>
                                    <td className="p-2.5 text-center whitespace-nowrap">
                                      {isRestored ? (
                                        <div className="space-y-0.5">
                                          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-100 text-emerald-800 dark:bg-emerald-950/60 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-700">
                                            <IconCheck size={11} stroke={3} /> Dikembalikan
                                          </span>
                                          <span className="block text-[10px] text-slate-400">
                                            oleh {it.restored_by?.name || 'Admin'}
                                          </span>
                                          {it.alasan_restore && (
                                            <span className="block text-[10px] text-slate-500 italic truncate max-w-[140px] mx-auto" title={it.alasan_restore}>
                                              "{it.alasan_restore}"
                                            </span>
                                          )}
                                        </div>
                                      ) : (
                                        <span
                                          className={`px-2 py-0.5 rounded text-[10px] font-bold ${
                                            it.status_item === 'approved' ||
                                            it.status_item === 'direct_deleted' ||
                                            it.status_item === 'deleted' ||
                                            isApproved
                                              ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300'
                                              : it.status_item === 'rejected' || isRejected
                                              ? 'bg-rose-100 text-rose-700 dark:bg-rose-950/60 dark:text-rose-300'
                                              : it.status_item === 'cancelled' ||
                                                it.status_item === 'dibatalkan' ||
                                                isCancelled
                                              ? 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300'
                                              : 'bg-amber-100 text-amber-700 dark:bg-amber-950/60 dark:text-amber-300'
                                          }`}
                                        >
                                          {it.status_item === 'approved' || it.status_item === 'direct_deleted' || it.status_item === 'deleted'
                                            ? 'Disetujui'
                                            : it.status_item === 'rejected'
                                            ? 'Ditolak'
                                            : it.status_item === 'cancelled' || it.status_item === 'dibatalkan'
                                            ? 'Dibatalkan'
                                            : 'Menunggu'}
                                        </span>
                                      )}
                                    </td>
                                    {isApprovedPengajuan && canVerify && (
                                      <td className="p-2.5 text-center whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
                                        {isRestored ? (
                                          <span className="text-[11px] font-semibold text-emerald-600 dark:text-emerald-400 flex items-center justify-center gap-1">
                                            <IconCheck size={14} /> Di Etalase
                                          </span>
                                        ) : (
                                          <button
                                            type="button"
                                            onClick={() => handleOpenRestoreModal(selectedPengajuan, [it.id || it.raw_child?.item_id])}
                                            className="px-2.5 py-1 text-xs font-bold bg-emerald-50 text-emerald-700 hover:bg-emerald-100 dark:bg-emerald-950/40 dark:text-emerald-300 rounded-lg border border-emerald-300 dark:border-emerald-700 flex items-center justify-center gap-1 transition-all cursor-pointer shadow-2xs mx-auto"
                                            title="Kembalikan barang ini ke etalase toko"
                                          >
                                            <IconRotateClockwise size={13} />
                                            <span>Kembalikan</span>
                                          </button>
                                        )}
                                      </td>
                                    )}
                                  </tr>
                                );
                              })
                            )}
                          </tbody>
                          {filteredModalItems.length > 0 && (
                            <tfoot className="bg-slate-50 dark:bg-slate-700/50 font-bold border-t border-slate-200 dark:border-slate-700 sticky bottom-0">
                              <tr>
                                <td colSpan={4} className="p-2.5 text-right text-slate-600 dark:text-slate-300 whitespace-nowrap">
                                  Total ({filteredModalItems.length} item):
                                </td>
                                <td className="p-2.5 text-right text-amber-600 dark:text-amber-400 font-mono whitespace-nowrap">
                                  {filteredModalItems
                                    .reduce((acc, it) => acc + parseFloat(it.berat || 0), 0)
                                    .toFixed(3)}{' '}
                                  gr
                                </td>
                                <td colSpan={isApprovedPengajuan && canVerify ? 3 : 2}></td>
                              </tr>
                            </tfoot>
                          )}
                        </table>
                      </div>
                    </div>
                  );
                })()}

                {/* 3. Tab Operator Pemohon */}
                {modalTab === 'operator' && (
                  <div className="space-y-4">
                    <div className="bg-slate-50 dark:bg-slate-700/30 p-5 rounded-2xl border border-slate-200 dark:border-slate-700">
                      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pb-4 border-b border-slate-200 dark:border-slate-600">
                        <div className="flex items-center gap-3.5">
                          <div className="w-12 h-12 rounded-2xl bg-amber-500/10 dark:bg-amber-400/20 text-amber-600 dark:text-amber-400 flex items-center justify-center font-bold text-lg border border-amber-200 dark:border-amber-700/50">
                            {userPemohon?.name ? userPemohon.name.charAt(0).toUpperCase() : <IconUser size={24} />}
                          </div>
                          <div>
                            <h4 className="font-bold text-base text-slate-800 dark:text-slate-100">
                              {userPemohon?.name || 'Operator Toko'}
                            </h4>
                            {userPemohon?.email && (
                              <p className="text-xs text-slate-500 dark:text-slate-400">
                                {userPemohon.email}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="px-2.5 py-1 text-[11px] font-bold rounded-lg bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 border border-amber-200 dark:border-amber-800">
                            {userPemohon?.roles
                              ? userPemohon.roles
                                  .map((r) => (typeof r === 'string' ? r : r.name).replace(/_/g, ' ').toUpperCase())
                                  .join(', ')
                              : userPemohon?.role
                              ? userPemohon.role.replace(/_/g, ' ').toUpperCase()
                              : 'OPERATOR TOKO'}
                          </span>
                          <span
                            className={`px-2.5 py-1 text-[11px] font-bold rounded-lg border ${
                              userPemohon?.is_active !== false && userPemohon?.is_active !== 0
                                ? 'bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800'
                                : 'bg-slate-100 dark:bg-slate-800 text-slate-500 border-slate-200'
                            }`}
                          >
                            {userPemohon?.is_active !== false && userPemohon?.is_active !== 0
                              ? '● Akun Aktif'
                              : '○ Non-Aktif'}
                          </span>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 pt-4 text-xs">
                        <div className="space-y-1">
                          <span className="text-slate-400 text-[11px] block">Cabang / Toko Asal</span>
                          <div className="flex items-center gap-1.5 font-bold text-slate-800 dark:text-slate-200">
                            <IconBuildingStore size={15} className="text-amber-500" />
                            <span>{selectedPengajuan.cabang?.nama_cabang || userPemohon?.cabang?.nama_cabang || '-'}</span>
                          </div>
                        </div>

                        <div className="space-y-1">
                          <span className="text-slate-400 text-[11px] block">Lokasi Toko</span>
                          <p className="font-semibold text-slate-700 dark:text-slate-300">
                            {selectedPengajuan.cabang?.lokasi || userPemohon?.cabang?.lokasi || '-'}
                          </p>
                        </div>

                        <div className="space-y-1">
                          <span className="text-slate-400 text-[11px] block">Waktu Pengajuan Permohonan</span>
                          <div className="flex items-center gap-1.5 font-semibold text-slate-700 dark:text-slate-300">
                            <IconClock size={15} className="text-slate-400" />
                            <span>{moment(selectedPengajuan.created_at).format('DD MMM YYYY, HH:mm')}</span>
                          </div>
                        </div>

                        <div className="space-y-1 sm:col-span-2 md:col-span-3 pt-2 border-t border-slate-200 dark:border-slate-600">
                          <span className="text-slate-400 text-[11px] block">Catatan yang Dilampirkan Pemohon</span>
                          <div className="p-3 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 font-medium leading-relaxed">
                            {selectedPengajuan.alasan || (
                              <span className="italic text-slate-400">Tidak ada catatan khusus dari pemohon.</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* 4. Tab Verifikator */}
                {modalTab === 'verifikator' && (
                  <div className="space-y-4">
                    {userVerifikator && !isCancelled ? (
                      <div className="bg-slate-50 dark:bg-slate-700/30 p-5 rounded-2xl border border-slate-200 dark:border-slate-700">
                        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pb-4 border-b border-slate-200 dark:border-slate-600">
                          <div className="flex items-center gap-3.5">
                            <div className="w-12 h-12 rounded-2xl bg-emerald-500/10 dark:bg-emerald-400/20 text-emerald-600 dark:text-emerald-400 flex items-center justify-center font-bold text-lg border border-emerald-200 dark:border-emerald-700/50">
                              {userVerifikator.name ? userVerifikator.name.charAt(0).toUpperCase() : <IconCircleCheck size={24} />}
                            </div>
                            <div>
                              <h4 className="font-bold text-base text-slate-800 dark:text-slate-100">
                                {userVerifikator.name}
                              </h4>
                              {userVerifikator?.email && (
                                <p className="text-xs text-slate-500 dark:text-slate-400">
                                  {userVerifikator.email}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <span className="px-2.5 py-1 text-[11px] font-bold rounded-lg bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800">
                              {userVerifikator.roles
                                ? userVerifikator.roles
                                    .map((r) => (typeof r === 'string' ? r : r.name).replace(/_/g, ' ').toUpperCase())
                                    .join(', ')
                                : userVerifikator.role
                                ? userVerifikator.role.replace(/_/g, ' ').toUpperCase()
                                : 'VERIFIKATOR PUSAT'}
                            </span>
                            <span
                              className={`px-2.5 py-1 text-[11px] font-bold rounded-lg border ${
                                isApproved
                                  ? 'bg-emerald-100 text-emerald-700 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-700'
                                  : isRejected
                                  ? 'bg-rose-100 text-rose-700 border-rose-300 dark:bg-rose-950/60 dark:text-rose-300 dark:border-rose-700'
                                  : 'bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-300'
                              }`}
                            >
                              {isApproved ? '✓ Disetujui' : isRejected ? '✕ Ditolak' : selectedPengajuan.status_pengajuan}
                            </span>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 pt-4 text-xs">
                          <div className="space-y-1">
                            <span className="text-slate-400 text-[11px] block">Unit / Cabang Verifikator</span>
                            <div className="flex items-center gap-1.5 font-bold text-slate-800 dark:text-slate-200">
                              <IconBuildingStore size={15} className="text-emerald-500" />
                              <span>{userVerifikator.cabang?.nama_cabang || 'Kantor Pusat / Owner'}</span>
                            </div>
                          </div>

                          <div className="space-y-1">
                            <span className="text-slate-400 text-[11px] block">Waktu Verifikasi Selesai</span>
                            <div className="flex items-center gap-1.5 font-semibold text-slate-700 dark:text-slate-300">
                              <IconClock size={15} className="text-emerald-500" />
                              <span>{moment(selectedPengajuan.updated_at).format('DD MMM YYYY, HH:mm:ss')}</span>
                            </div>
                          </div>

                          <div className="space-y-1">
                            <span className="text-slate-400 text-[11px] block">Status Akun</span>
                            <span className="font-semibold text-emerald-600 dark:text-emerald-400">
                              {userVerifikator.is_active !== false && userVerifikator.is_active !== 0 ? '● Aktif' : '○ Non-Aktif'}
                            </span>
                          </div>

                          <div className="space-y-1 sm:col-span-2 md:col-span-3 pt-2 border-t border-slate-200 dark:border-slate-600">
                            <span className="text-slate-400 text-[11px] block">Catatan / Keterangan Verifikator</span>
                            <div className="p-3 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 font-medium leading-relaxed">
                              {(
                                selectedPengajuan.catatan_verifikasi ||
                                selectedPengajuan.catatan_verifikator ||
                                selectedPengajuan.catatan
                              ) ? (
                                selectedPengajuan.catatan_verifikasi ||
                                selectedPengajuan.catatan_verifikator ||
                                selectedPengajuan.catatan
                              ) : (
                                <span className="italic text-slate-400">
                                  Tidak ada catatan atau instruksi khusus dari verifikator.
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : isCancelled ? (
                      <div className="p-8 text-center bg-slate-50 dark:bg-slate-700/20 rounded-2xl border border-slate-200 dark:border-slate-700 space-y-3">
                        <div className="w-12 h-12 mx-auto rounded-full bg-slate-200 dark:bg-slate-700 text-slate-500 flex items-center justify-center">
                          <IconAlertTriangle size={24} />
                        </div>
                        <h4 className="font-bold text-sm text-slate-800 dark:text-slate-100">
                          Permohonan Telah Dibatalkan
                        </h4>
                        <p className="text-xs text-slate-500 dark:text-slate-400 max-w-md mx-auto">
                          Permohonan pengajuan hapus etalase ini telah dibatalkan sebelum diproses oleh Admin / Verifikator.
                        </p>
                      </div>
                    ) : (
                      <div className="p-8 text-center bg-amber-50/50 dark:bg-amber-900/10 rounded-2xl border border-amber-200/60 dark:border-amber-900/30 space-y-3">
                        <div className="w-12 h-12 mx-auto rounded-full bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 flex items-center justify-center">
                          <IconClock size={24} />
                        </div>
                        <h4 className="font-bold text-sm text-amber-800 dark:text-amber-300">Menunggu Verifikator</h4>
                        <p className="text-xs text-slate-600 dark:text-slate-400 max-w-md mx-auto">
                          Permohonan ini berstatus <strong className="text-amber-700 dark:text-amber-400">Menunggu Persetujuan</strong> dan sedang dalam antrean pemeriksaan oleh tim Admin Pusat / Owner / Verifikator. Informasi detail akun verifikator akan muncul secara otomatis setelah pengajuan disetujui atau ditolak.
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {/* 5. Tab Galeri List Item */}
                {modalTab === 'galeri' && (
                  <div className="space-y-4">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                      <div className="relative flex-1 max-w-xs">
                        <IconSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={15} />
                        <input
                          type="text"
                          placeholder="Cari kode, jenis, baki..."
                          value={searchModalItem}
                          onChange={(e) => setSearchModalItem(e.target.value)}
                          className="w-full pl-8 pr-3 py-1.5 text-xs bg-slate-50 dark:bg-slate-700/50 border border-slate-200 dark:border-slate-600 rounded-lg outline-none focus:border-amber-400 focus:ring-1 focus:ring-amber-200"
                        />
                      </div>
                      <span className="text-[11px] text-slate-500 font-medium">
                        Menampilkan {filteredModalItems.length} foto item
                      </span>
                    </div>

                    {filteredModalItems.length === 0 ? (
                      <div className="py-12 text-center text-slate-400">
                        <IconInbox size={36} className="mx-auto mb-2 opacity-50" />
                        <p className="text-xs">Tidak ada item yang sesuai dengan pencarian</p>
                      </div>
                    ) : (
                      <PhotoProvider>
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                          {filteredModalItems.map((item) => {
                            const imgUrl = resolveItemImageUrl(item);
                            return (
                              <div
                                key={item.id || item.kode_item}
                                className="bg-white dark:bg-slate-800 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 hover:shadow-md transition-shadow group flex flex-col"
                              >
                                <div className="aspect-square bg-slate-100 dark:bg-slate-700/50 relative flex items-center justify-center overflow-hidden">
                                  {imgUrl ? (
                                    <PhotoView src={imgUrl}>
                                      <img
                                        src={imgUrl}
                                        alt={item.kode_item}
                                        className="w-full h-full object-cover cursor-pointer hover:scale-105 transition-transform duration-200"
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = '';
                                        }}
                                      />
                                    </PhotoView>
                                  ) : (
                                    <div className="flex flex-col items-center justify-center text-slate-400 p-4 text-center">
                                      <IconPhoto size={28} className="opacity-40 mb-1" />
                                      <span className="text-[10px]">Tidak ada foto</span>
                                    </div>
                                  )}
                                  <span className="absolute top-1.5 right-1.5 px-1.5 py-0.5 rounded bg-black/60 backdrop-blur-xs text-white text-[10px] font-mono font-bold">
                                    {item.karat}K
                                  </span>
                                </div>

                                <div
                                  onClick={() => showDetailItem(item)}
                                  className="p-2.5 flex-1 flex flex-col justify-between text-xs cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors"
                                >
                                  <div>
                                    <span className="font-mono font-bold text-amber-600 dark:text-amber-400 block truncate">
                                      {item.kode_item}
                                    </span>
                                    <span className="text-slate-600 dark:text-slate-300 font-medium block truncate text-[11px]">
                                      {item.jenis_kategori?.nama_jenis || '-'}
                                    </span>
                                  </div>
                                  <div className="flex items-center justify-between mt-2 pt-1.5 border-t border-slate-100 dark:border-slate-700 text-[11px]">
                                    <span className="text-slate-400">Baki: {item.nomor_rak || '-'}</span>
                                    <span className="font-bold text-slate-800 dark:text-slate-200">
                                      {parseFloat(item.berat || 0).toFixed(3)} gr
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </PhotoProvider>
                    )}
                  </div>
                )}
              </div>

              {/* Modal Footer */}
              <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-3 border-t border-slate-100 dark:border-slate-700 flex-shrink-0">
                <div className="text-[11px] text-slate-500 max-w-md truncate">
                  {selectedPengajuan.alasan && (
                    <span>
                      <strong className="text-slate-600 dark:text-slate-400">Alasan:</strong> {selectedPengajuan.alasan}
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-2 self-end sm:self-auto">
                  <button
                    type="button"
                    onClick={() => setIsOpenDetailModal(false)}
                    className="px-4 py-2 text-xs font-semibold text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-xl transition-all cursor-pointer"
                  >
                    Tutup
                  </button>

                  {isVerifikasi && isPending && canVerify && (
                    <>
                      <button
                        type="button"
                        onClick={() => confirmAction(selectedPengajuan.id, 'reject')}
                        className="px-4 py-2 text-xs font-bold text-white bg-rose-600 hover:bg-rose-700 rounded-xl shadow-lg shadow-rose-600/20 transition-all flex items-center gap-1.5 cursor-pointer"
                      >
                        <IconX size={15} /> Tolak Pengajuan
                      </button>
                      <button
                        type="button"
                        onClick={() => confirmAction(selectedPengajuan.id, 'approve')}
                        className="px-4 py-2 text-xs font-bold text-white bg-emerald-600 hover:bg-emerald-700 rounded-xl shadow-lg shadow-emerald-600/20 transition-all flex items-center gap-1.5 cursor-pointer"
                      >
                        <IconCheck size={15} /> Setujui & Hapus dari Etalase
                      </button>
                    </>
                  )}

                  {!isVerifikasi && isPending && !canVerify && (
                    <button
                      type="button"
                      onClick={() => confirmAction(selectedPengajuan.id, 'cancel')}
                      className="px-4 py-2 text-xs font-bold text-white bg-slate-600 hover:bg-slate-700 rounded-xl transition-all flex items-center gap-1.5 cursor-pointer"
                    >
                      <IconX size={15} /> Batalkan Pengajuan
                    </button>
                  )}
                </div>
              </div>
                      </>
                    );
                  })()}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      {/* Modal Konfirmasi Persetujuan / Penolakan */}
      {confirmModal.isOpen && (
        <div className="fixed inset-0 z-[10000] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white dark:bg-slate-800 w-full max-w-lg rounded-2xl p-6 shadow-2xl space-y-4 border border-slate-200 dark:border-slate-700">
            <div className="flex items-center justify-between border-b border-slate-100 dark:border-slate-700 pb-3">
              <h3 className="font-bold text-sm text-slate-800 dark:text-slate-100 flex items-center gap-2">
                {confirmModal.action === 'approve' ? (
                  <IconCheck className="text-emerald-500" size={18} />
                ) : confirmModal.action === 'reject' ? (
                  <IconX className="text-rose-500" size={18} />
                ) : (
                  <IconAlertTriangle className="text-amber-500" size={18} />
                )}
                <span>
                  {confirmModal.action === 'approve'
                    ? 'Konfirmasi Persetujuan Permohonan'
                    : confirmModal.action === 'reject'
                    ? 'Konfirmasi Penolakan Permohonan'
                    : 'Konfirmasi Pembatalan Permohonan'}
                </span>
              </h3>
              <button
                type="button"
                onClick={() => setConfirmModal({ isOpen: false, id: null, action: null, pengajuan: null })}
                className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 p-1 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700/60 transition-colors cursor-pointer"
              >
                <IconX size={18} />
              </button>
            </div>

            {confirmModal.pengajuan && (
              <div className="bg-slate-50 dark:bg-slate-700/40 p-3.5 rounded-xl border border-slate-200 dark:border-slate-700 text-xs space-y-1.5 text-slate-700 dark:text-slate-300">
                <p>
                  <strong className="text-slate-900 dark:text-slate-100">No. Request:</strong>{' '}
                  <span className="font-mono font-bold text-amber-600 dark:text-amber-400">
                    {confirmModal.pengajuan.batch_id}
                  </span>
                </p>
                <p>
                  <strong className="text-slate-900 dark:text-slate-100">Asal Toko:</strong>{' '}
                  <span className="text-slate-700 dark:text-slate-200">
                    {confirmModal.pengajuan.cabang?.nama_cabang || '-'}
                  </span>
                </p>
                <p>
                  <strong className="text-slate-900 dark:text-slate-100">Pemohon:</strong>{' '}
                  <span className="text-slate-700 dark:text-slate-200">
                    {confirmModal.pengajuan.diajukan_oleh?.name ||
                      confirmModal.pengajuan.user_pemohon?.name ||
                      'Sistem'}
                  </span>
                </p>
                <p>
                  <strong className="text-slate-900 dark:text-slate-100">Total Barang:</strong>{' '}
                  <span className="text-slate-700 dark:text-slate-200">
                    {confirmModal.pengajuan.items?.length || 0} Pcs (
                    {parseFloat(
                      confirmModal.pengajuan.items?.reduce(
                        (total, child) => total + parseFloat((child.item || child)?.berat || 0),
                        0
                      ) || 0
                    ).toFixed(3)}{' '}
                    gr)
                  </span>
                </p>
              </div>
            )}

            <form onSubmit={processConfirmAction} className="space-y-4">
              <div>
                <label className="block text-xs font-bold text-slate-600 dark:text-slate-300 mb-1.5">
                  Catatan Verifikasi{' '}
                  {confirmModal.action === 'reject' && (
                    <span className="text-rose-500">* (Wajib diisi jika menolak)</span>
                  )}
                </label>
                <textarea
                  rows={3}
                  placeholder={
                    confirmModal.action === 'approve'
                      ? 'Catatan opsional...'
                      : confirmModal.action === 'reject'
                      ? 'Jelaskan alasan penolakan...'
                      : 'Alasan pembatalan (opsional)...'
                  }
                  value={catatanVerifikasi}
                  onChange={(e) => setCatatanVerifikasi(e.target.value)}
                  required={confirmModal.action === 'reject'}
                  className="w-full p-2.5 text-xs border border-slate-300 dark:border-slate-600 rounded-xl bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none focus:ring-2 focus:ring-amber-500"
                />
              </div>

              <div className="flex justify-end gap-2 pt-2 border-t border-slate-100 dark:border-slate-700">
                <button
                  type="button"
                  onClick={() => setConfirmModal({ isOpen: false, id: null, action: null, pengajuan: null })}
                  className="px-4 py-2 text-xs font-semibold text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-xl transition-all border border-slate-200 dark:border-slate-700 cursor-pointer"
                  disabled={loading}
                >
                  Batal
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className={`px-5 py-2 text-xs font-bold text-white rounded-xl shadow-lg transition-all flex items-center gap-1.5 cursor-pointer ${
                    confirmModal.action === 'approve'
                      ? 'bg-emerald-600 hover:bg-emerald-700 shadow-emerald-600/20'
                      : confirmModal.action === 'reject'
                      ? 'bg-rose-600 hover:bg-rose-700 shadow-rose-600/20'
                      : 'bg-slate-600 hover:bg-slate-700'
                  }`}
                >
                  {loading ? (
                    <span className="loading loading-spinner loading-xs"></span>
                  ) : confirmModal.action === 'approve' ? (
                    'Setujui & Hapus dari Etalase'
                  ) : confirmModal.action === 'reject' ? (
                    'Tolak Pengajuan'
                  ) : (
                    'Batalkan Pengajuan'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ========================================================================= */}
      {/* MODAL KONFIRMASI PENGEMBALIAN BARANG KE ETALASE                          */}
      {/* ========================================================================= */}
      {restoreModal.isOpen && (
        <div className="fixed inset-0 z-[99999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white dark:bg-slate-900 w-full max-w-lg rounded-2xl p-5 sm:p-6 shadow-2xl space-y-4 border border-slate-200 dark:border-slate-800 animate-in zoom-in-95 duration-150">
            <div className="flex items-center justify-between pb-3 border-b border-slate-100 dark:border-slate-800">
              <h3 className="font-bold text-sm text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span className="p-1.5 bg-emerald-100 dark:bg-emerald-950 text-emerald-600 dark:text-emerald-400 rounded-lg">
                  <IconRotateClockwise size={18} />
                </span>
                <span>Kembalikan Barang ke Etalase</span>
              </h3>
              <button
                type="button"
                onClick={() => setRestoreModal({ isOpen: false, pengajuan: null, itemIds: [], itemsList: [] })}
                className="text-slate-400 hover:text-slate-600 p-1 cursor-pointer"
              >
                <IconX size={18} />
              </button>
            </div>

            {/* Info Pengajuan & Target Item */}
            <div className="p-3.5 bg-slate-50 dark:bg-slate-800/60 rounded-xl text-xs space-y-2 border border-slate-200/80 dark:border-slate-700">
              <div className="flex justify-between">
                <span className="text-slate-500">No. Pengajuan:</span>
                <span className="font-mono font-bold text-amber-600 dark:text-amber-400">
                  {restoreModal.pengajuan?.batch_id}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-500">Cabang:</span>
                <span className="font-semibold text-slate-800 dark:text-slate-200">
                  {restoreModal.pengajuan?.cabang?.nama_cabang || '-'}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-500">Jumlah Barang Dikembalikan:</span>
                <span className="font-bold text-emerald-600 dark:text-emerald-400">
                  {restoreModal.itemsList.length} item ({parseFloat(
                    restoreModal.itemsList.reduce((acc, it) => acc + parseFloat(it.berat || 0), 0)
                  ).toFixed(3)} gr)
                </span>
              </div>

              {/* Ringkasan item yang akan dikembalikan */}
              <div className="pt-2 border-t border-slate-200 dark:border-slate-700">
                <span className="text-[11px] font-semibold text-slate-500 block mb-1">
                  Daftar Item:
                </span>
                <div className="max-h-28 overflow-y-auto space-y-1 pr-1">
                  {restoreModal.itemsList.map((it, idx) => (
                    <div
                      key={it.id || idx}
                      className="flex items-center justify-between text-[11px] bg-white dark:bg-slate-900 px-2 py-1 rounded border border-slate-200/60 dark:border-slate-800"
                    >
                      <span className="font-mono font-bold text-amber-600 dark:text-amber-400">
                        {it.kode_item}
                      </span>
                      <span className="truncate max-w-[180px] text-slate-700 dark:text-slate-300">
                        {it.jenis_kategori?.nama_jenis || it.nama_barang || '-'}
                      </span>
                      <span className="font-mono text-slate-600 dark:text-slate-400 font-semibold">
                        {parseFloat(it.berat || 0).toFixed(3)} gr
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="p-3 bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 rounded-xl text-xs text-amber-800 dark:text-amber-300">
              <p className="font-semibold">Catatan Audit & Sistem:</p>
              <p className="text-[11px] mt-0.5 opacity-90">
                Barang akan diaktifkan kembali ke etalase toko (status: ready). Catatan riwayat pengajuan hapus tetap disimpan untuk audit lengkap.
              </p>
            </div>

            <form onSubmit={handleProcessRestore} className="space-y-4">
              <div>
                <label className="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1.5">
                  Alasan Pengembalian <span className="text-rose-500">* (Wajib diisi)</span>
                </label>
                <textarea
                  rows={3}
                  placeholder="Contoh: Pembatalan hapus karena kesalahan pilih barang oleh operator..."
                  value={alasanRestore}
                  onChange={(e) => setAlasanRestore(e.target.value)}
                  required
                  className="w-full p-3 text-xs border border-slate-300 dark:border-slate-700 rounded-xl bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-emerald-500 resize-none"
                />
              </div>

              <div className="flex justify-end gap-2 pt-2 border-t border-slate-100 dark:border-slate-800">
                <button
                  type="button"
                  onClick={() => setRestoreModal({ isOpen: false, pengajuan: null, itemIds: [], itemsList: [] })}
                  className="px-4 py-2.5 text-xs font-semibold text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl cursor-pointer"
                >
                  Batal
                </button>
                <button
                  type="submit"
                  disabled={isSubmittingRestore}
                  className="px-5 py-2.5 text-xs font-bold text-white bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 rounded-xl shadow-md transition-all flex items-center gap-1.5 cursor-pointer disabled:opacity-50"
                >
                  {isSubmittingRestore ? (
                    <>
                      <span className="loading loading-spinner loading-xs"></span>
                      <span>Memproses...</span>
                    </>
                  ) : (
                    <>
                      <IconRotateClockwise size={16} />
                      <span>Kembalikan ke Etalase</span>
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </Layouts>
  );
}
